import store from "@/store";

export async function errorHandler (error) {
    if(error && error.response && error.response.status == 401){
        store.dispatch('user/logout', {}, {root:true})
    }

    // log difensivo: error.response può mancare (network error, richiesta annullata)
    // eslint-disable-next-line no-console
    console.log(
        '[api-error]',
        error && error.config ? error.config.url : '(no url)',
        error ? error.message : '',
        error && error.response ? error.response.data : '(no response)'
    )

    if(error && error.response && error.response.data){
        return error.response.data
    }else if(error && error.message){
        return error.message
    }else {
        return error;
    }

}
